var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 604,
    height: 218,
    viewBox: "0 0 604 218",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2L602 2V87H2L2 179.5 V179.5 C2 197.5 17.5 216 38.5 216H565.5C586.5 216 602 197.5 602 179.5C602 161.5 586.5 143 565.5 143H38.5C17.5 143 2 161.5 2 179.5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF75C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#FFA647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183,
    stopColor: "#FFE83F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    stopColor: "#9FFF5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392,
    stopColor: "#70E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#CD93FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#CD93FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.646,
    stopColor: "#70E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#9FFF5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.819,
    stopColor: "#FFE83F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.907,
    stopColor: "#FFA647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF75C3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrack);
export default __webpack_public_path__ + "static/media/track.1a8e7c06d1b176c1e87b0b8afaf03557.svg";
export { ForwardRef as ReactComponent };